import { ApiStepperItem, STEP_FROM_NUMBER, STEP_ORDER, StepState, StepStatus } from './onboarding-wizard-stepper';

const ALLOWED = new Set<StepStatus>(['pending','inProgress','completed']);

export function emptySteps(): StepState[] {
  return STEP_ORDER.map(k => ({ step: k, status: 'pending', updatedAt: null, updatedBy: null }));
}

export function normalizeFromApi(items: ApiStepperItem[]): StepState[] {
  const base = emptySteps();

  for (const it of items) {
    const idxNum = Math.max(0, Math.min(STEP_ORDER.length - 1, Number(it.step) - 1));
    const key = STEP_FROM_NUMBER[idxNum + 1];
    const raw = (it.status as StepStatus);
    const mapped: StepStatus = ALLOWED.has(raw) ? raw : 'pending';

    const idx = STEP_ORDER.indexOf(key);
    base[idx] = {
      ...base[idx],
      status: mapped,
      updatedAt: it.updatedAt ?? it.createdAt ?? null,
      updatedBy: null,
    };
  }

  const inProg = base.map((s,i)=>s.status==='inProgress'?i:-1).filter(i=>i>=0);
  if (inProg.length > 1) inProg.slice(1).forEach(i => base[i] = { ...base[i], status: 'pending' });

  return base;
}
